import birdLogo from '../../assets/matou-bird-logo-grey.svg';
import textLogo from '../../assets/matou-text-logo-white.svg';
import JoinForm from './components/JoinForm';

// Standalone /join page. Like the legal pages, the home Navigation/Footer
// scroll to on-page anchors that don't exist here, so this page carries its
// own slim header and footer with the same brand tokens.
export default function Join() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-matou-bg text-matou-text font-mono flex flex-col">
      <header className="bg-matou-teal-dark">
        <div className="max-w-content mx-auto px-4 md:px-8">
          <div className="flex items-center h-16">
            <a href="/" className="flex items-center gap-3">
              <img src={birdLogo} alt="Mātou bird" className="h-6" />
              <img src={textLogo} alt="Mātou Collective" className="h-5" />
            </a>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 md:px-8 py-12 md:py-16">
          {/* Welcome */}
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-matou-teal-dark mb-2">
            Join Mātou Collective
          </h1>
          <p className="font-mono text-sm text-matou-text-muted mb-8">
            By Indigenous Hands, for Indigenous Futures
          </p>
          <div className="space-y-4 font-mono text-sm leading-relaxed mb-10">
            <p>
              Ngā mihi — thank you for connecting with us. We appreciate you
              taking the time to register your interest in being part of our
              kaupapa (purpose, cause).
            </p>
            <p>
              Mātou Collective is an Indigenous-led digital organisation
              committed to creating systems, governance models, and economic
              infrastructure that supports our communities' digital
              sovereignty.
            </p>
            <p>
              Our work begins here in Aotearoa, with a vision to share
              Indigenous-led digital pathways across the world.
            </p>
          </div>

          <JoinForm />
        </div>
      </main>

      <footer className="bg-matou-teal-dark py-6">
        <div className="max-w-content mx-auto px-4 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs text-white/60">
            © {currentYear} Mātou Collective
          </p>
          <div className="flex gap-4">
            <a href="/terms" className="font-mono text-xs text-white/60 hover:text-white transition-colors">Terms of use</a>
            <a href="/privacy" className="font-mono text-xs text-white/60 hover:text-white transition-colors">Privacy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
